import React from 'react';
import { Box, Container, Heading, Text, Button, VStack, HStack, Badge, Icon } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FiHome, FiBookOpen, FiHelpCircle, FiCompass } from 'react-icons/fi';

function NotFound() {
  return (
    <Box bg="#F8FAFC" minH="85vh" py={{ base: 12, md: 20 }} display="flex" alignItems="center">
      <Container maxW="lg" px={4}>
        <Box
          bg="white"
          borderRadius="2xl"
          p={{ base: 8, md: 12 }}
          boxShadow="sm"
          border="1px solid"
          borderColor="gray.100"
          textAlign="center"
        >
          <Box
            w="80px"
            h="80px"
            mx="auto"
            mb={6}
            borderRadius="full"
            bg="blue.50"
            color="#162237"
            display="flex"
            alignItems="center"
            justifyContent="center"
            boxShadow="0 0 0 10px rgba(22, 34, 55, 0.05)"
          >
            <Icon as={FiCompass} boxSize={10} color="#162237" />
          </Box>

          <Badge
            bg="rgba(234, 179, 8, 0.15)"
            color="#B45309"
            px={3}
            py={1}
            borderRadius="full"
            fontSize="xs"
            fontWeight="bold"
            letterSpacing="wider"
            textTransform="uppercase"
            mb={3}
          >
            404 Error: Missing Citation
          </Badge>

          <Heading size="xl" color="#162237" fontWeight="black" mb={3}>
            Page Not Located
          </Heading>

          <Text fontSize="sm" color="gray.600" mb={8} lineHeight="tall">
            The legal commentary, court docket, or digital resource you requested does not exist or has been relocated to another registry section.
          </Text>

          <VStack spacing={3} align="stretch">
            <Button
              as={Link}
              to="/"
              size="lg"
              bg="#162237"
              color="white"
              leftIcon={<FiHome />}
              _hover={{ bg: '#0B132B', transform: 'translateY(-1px)' }}
              transition="all 0.2s"
            >
              Return to Storefront
            </Button>

            <HStack spacing={3}>
              <Button
                as={Link}
                to="/products"
                flex={1}
                variant="outline"
                borderColor="gray.200"
                leftIcon={<FiBookOpen />}
                _hover={{ bg: 'gray.50' }}
              >
                Browse Books
              </Button>
              <Button
                as={Link}
                to="/contact"
                flex={1}
                variant="outline"
                borderColor="gray.200"
                leftIcon={<FiHelpCircle />}
                _hover={{ bg: 'gray.50' }}
              >
                Get Help
              </Button>
            </HStack>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
}

export default NotFound;